export const USER_STORE_DATA_ENUM = {
    creditScore: "creditScore",
    bankName: "bankName",
    bankBranch: "bankBranch",
    companyName: "companyName",
    companyAddress: "companyAddress",
    customerDetails: "customerDetails",
    loanDetails: "loanDetails",
    companyType: "companyType",
    userSalary: "userSalary",
    isUserTrackedInNetCore: "isUserTrackedInNetCore",
    gtmTimelineEvents: (applicationId: string) => `gtmTimelineEvents_${applicationId}`,
};

export enum USER_TYPE_ENUM {
    NEW_USER = "new_user",
    REPEAT_USER = "repeat_user",
}
